/**
 * What a stored payment method means.
 *
 * A copy of src/lib/payment.js in lumiere-mobile, where it is tested; kept
 * identical so the app and the website label an order the same way.
 *
 * Orders store the method as the words the checkout sent — 'Cash on
 * Delivery' or 'MyFatoorah' — from both the app and the website. Screens were
 * comparing that against 'cod', which it never is, so every bill and every
 * order said "Card" for customers paying cash at the door. One reader, used
 * everywhere, so the label cannot drift between screens again.
 *
 * Older and hand-made orders may use other spellings, so matching is by
 * meaning rather than by one exact string. Anything unrecognised is reported
 * as unknown rather than guessed: a receipt should not state a payment method
 * it does not actually know.
 */
const CASH = /^(cod|cash|cash[\s_-]*on[\s_-]*delivery|pay[\s_-]*on[\s_-]*delivery)$/;
const CARD = /^(card|credit[\s_-]*card|debit[\s_-]*card|online|myfatoorah|my[\s_-]*fatoorah|apple[\s_-]*pay)$/;

/** @returns {'cod' | 'card' | null} */
export const paymentKind = method => {
  if (method == null) return null;
  const m = String(method).trim().toLowerCase();
  if (!m) return null;
  if (CASH.test(m)) return 'cod';
  if (CARD.test(m)) return 'card';
  return null;
};
